function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.004 8.967v2.807a2.103 2.103 0 01-.52 1.643c-.709.778-1.86.777-2.57 0L.937 8.732A1.824 1.824 0 01.6 8.469l-.067-.052A2.087 2.087 0 010 7c0-.222.032-.445.099-.658.16-.52.512-.946.963-1.174L6.915.584c.71-.778 1.86-.779 2.57-.001.409.448.582 1.058.519 1.643v2.76h28.178c1.004 0 1.818.891 1.818 1.99 0 1.1-.814 1.99-1.818 1.99H10.004z",
  fill: "currentColor"
});

var SvgBack = function SvgBack(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 14,
    viewBox: "0 0 40 14",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='40' height='14' viewBox='0 0 40 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.0035 8.96654V11.7745C10.067 12.3593 9.89397 12.9689 9.4845 13.4174C8.77505 14.1946 7.62449 14.1942 6.91453 13.4165L0.935786 8.73251C0.81709 8.66042 0.704208 8.57265 0.599665 8.46919L0.532766 8.41677C0.175688 8.02565 -0.00190451 7.51241 1.54002e-05 6.99995C-0.000817872 6.77752 0.0321638 6.55496 0.0989582 6.34229C0.258912 5.82116 0.610538 5.39641 1.06212 5.16841L6.91453 0.583634C7.62449 -0.194147 8.77505 -0.194565 9.4845 0.582505C9.89397 1.03119 10.067 1.64074 10.0035 2.22552V4.98642H38.1821C39.1862 4.98642 40 5.87741 40 6.9766C40 8.07567 39.1862 8.96654 38.1821 8.96654H10.0035Z' fill='currentColor'/%3E %3C/svg%3E";
export { SvgBack as ReactComponent };